import { render, staticRenderFns } from "./incomedetail.vue?vue&type=template&id=6f8e9e02&scoped=true&"
import script from "./incomedetail.vue?vue&type=script&lang=js&"
export * from "./incomedetail.vue?vue&type=script&lang=js&"
import style0 from "./incomedetail.vue?vue&type=style&index=0&id=6f8e9e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e9e02",
  null
  
)

export default component.exports